<div class="admin-page-actions">
    <smart-icon (click)="onEditClick()" name="pencil" class="light" [style.display]="editable? 'block':'none'">
    </smart-icon>
    <smart-icon (click)="onDeleteClick()" name="trash" class="light" [style.display]="deletable? 'block':'none'">
    </smart-icon>
</div>